import React from "react";
import { Form } from "react-bootstrap";

const InputInteger = React.forwardRef(({ value, onInteger, onChange, ...rest }, ref) => {

    function handleChange(e) {
        let inputValue = e.target.value;
        
        let rawValue = parseInt(inputValue.replace(/\D/g, ''));

        if((rawValue || rawValue === 0) && !isNaN(rawValue)) {
            if(inputValue.indexOf('-') >= 0) rawValue *= -1
            if(inputValue.indexOf('+') >= 0 && rawValue < 0) rawValue *= -1;
        } else rawValue = undefined;


        if(onChange) onChange({ target: { ...e.target, value: rawValue }});
        if(onInteger) onInteger(rawValue);
    }

    return (
        <Form.Control
            value={value}
            onChange={handleChange}
            ref={ref}
            {...rest}
        />
    )

});

export default InputInteger;